(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["et-gift-builder"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const data = JSON.parse(root.querySelector('[data-gift-data]').textContent);
    const el = (name) => root.querySelector(`[data-${name}]`);
    const form = el('gift-form');
    const familyRadios = [...root.querySelectorAll('[name=model]')];
    const finishRadios = [...root.querySelectorAll('[name=finish]')];
    const engraving = el('gift-engraving');
    const text = el('gift-text');
    const engravingPattern = text.getAttribute('pattern');
    const box = el('gift-box');
    const message = el('gift-message');
    const buttons = [...root.querySelectorAll('[data-gift-add]')];
    const each = (name, update) => root.querySelectorAll(`[data-${name}]`).forEach(update);
    const setText = (name, value) => each(name, node => { if (node.textContent !== value) node.textContent = value; });
    const ack = el('preorder-ack');
    const formatter = new Intl.NumberFormat(data.locale, {style:'currency', currency:data.currency, currencyDisplay:'narrowSymbol', minimumFractionDigits:0, maximumFractionDigits:2});
    const money = (cents) => `${formatter.format(cents / 100)} ${data.currency}`;
    let busy = false;
    let uncertain = false;
    let product;
    let engaged = false;
    const dock = el('gift-dock');
    const dockToggle = el('dock-toggle');
    const dockDetails = el('dock-details');
    const mobile = window.matchMedia('(max-width:899px)');
    const lifecycle = new AbortController();
    const signal = lifecycle.signal;
    let frame = 0;
    let pulseTimer;
    const closeDetails = () => {
      dockDetails.hidden = true;
      dockToggle.setAttribute('aria-expanded', 'false');
    };
    const updateDock = () => {
      frame = 0;
      const cta = el('main-add').getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const mainVisible = cta.top < viewportHeight && cta.bottom > 0;
      const typing = mobile.matches && document.activeElement?.matches('input[type=text],input[type=email],input[type=search],textarea,[contenteditable=true]');
      const covered = !!document.querySelector('dialog[open]');
      const heroVisible = root.querySelector('.eg-intro-band').getBoundingClientRect().bottom > 0;
      dock.hidden = !engaged || mainVisible || typing || covered || heroVisible;
      if (dock.hidden) closeDetails();
      else {
        const height = el('dock-rail').getBoundingClientRect().height + (parseFloat(getComputedStyle(dock).paddingBottom) || 0);
        document.body.style.setProperty('--gift-dock-space', `${Math.ceil(height)}px`);
      }
    };
    const scheduleDock = () => { if (!frame) frame = requestAnimationFrame(updateDock); };
    const engage = () => {
      engaged = true;
      root.dataset.dockEngaged = 'true';
      scheduleDock();
    };
    const pulse = () => {
      clearTimeout(pulseTimer);
      delete dock.dataset.updated;
      requestAnimationFrame(() => { dock.dataset.updated = 'true'; });
      pulseTimer = setTimeout(() => { delete dock.dataset.updated; }, 750);
    };
    dockToggle.addEventListener('click', () => {
      dockDetails.hidden = !dockDetails.hidden;
      dockToggle.setAttribute('aria-expanded', String(!dockDetails.hidden));
    });
    el('dock-close').addEventListener('click', () => { closeDetails(); dockToggle.focus(); });
    dock.addEventListener('keydown', event => {
      if (event.key === 'Escape') { closeDetails(); dockToggle.focus(); }
    });
    root.querySelectorAll('[data-gift-edit]').forEach(link => link.addEventListener('click', event => {
      event.preventDefault();
      closeDetails();
      const target = link.dataset.giftEdit === 'model' ? familyRadios.find(radio => radio.checked) : link.dataset.giftEdit === 'engraving' ? text : message;
      target.scrollIntoView({block:'center', behavior:'instant'});
      target.focus({preventScroll:true});
      scheduleDock();
    }));
    ['scroll', 'resize'].forEach(type => window.addEventListener(type, scheduleDock, {passive:true, signal}));
    ['focusin', 'focusout'].forEach(type => document.addEventListener(type, scheduleDock, {signal}));
    window.visualViewport?.addEventListener('resize', scheduleDock, {passive:true, signal});
    const dialogs = new MutationObserver(scheduleDock);
    dialogs.observe(document.body, {subtree:true, attributes:true, attributeFilter:['open']});
    document.addEventListener('shopify:section:unload', event => {
      if (!event.target.contains(root)) return;
      lifecycle.abort(); dialogs.disconnect(); cancelAnimationFrame(frame); clearTimeout(pulseTimer);
      document.body.style.removeProperty('--gift-dock-space');
    }, {signal});
    // Both purchase buttons share the same validation and cart request.
    form.noValidate = true;
    const refresh = () => {
      engraving.disabled = !data.engraving.available || !product.personalisable;
      if (engraving.disabled) engraving.checked = false;
      text.disabled = engraving.disabled;
      if (engraving.checked) text.setAttribute('pattern', engravingPattern);
      else text.removeAttribute('pattern');
      text.required = engraving.checked;
      text.setCustomValidity(engraving.checked && !text.value.trim() ? data.labels.emptyEngraving : '');
      message.disabled = box.disabled;
      const sample = text.value.trim();
      el('preview-text').querySelector('textPath').textContent = engraving.checked && sample ? sample : data.labels.previewDefault;
      el('preview-text').setAttribute('fill-opacity', engraving.checked && sample ? '0.95' : '0.28');
      el('message-count').textContent = message.value.length;
      each('summary-engraving-row', node => { node.hidden = !engraving.checked; });
      each('summary-box-row', node => { node.hidden = !box.checked; });
      setText('summary-racket', money(product.price));
      setText('summary-engraving', money(data.engraving.price));
      setText('summary-box', money(data.box.price));
      setText('summary-text', sample || data.labels.enterName);
      setText('summary-message', message.value.trim());
      setText('gift-total', money(product.price + (engraving.checked ? data.engraving.price : 0) + (box.checked ? data.box.price : 0)));
      setText('dock-options', [engraving.checked ? `${data.labels.engraving}${sample ? ` · ${sample}` : ''}` : '', box.checked ? data.labels.box : ''].filter(Boolean).join(' / ') || data.labels.racketOnly);
      ack.required = product.preorder;
      ack.disabled = !product.preorder;
      buttons.forEach(button => {
        button.disabled = busy || uncertain || !product.available;
        button.textContent = busy ? data.labels.adding : data.labels.add;
      });
      scheduleDock();
    };
    const choose = () => {
      const family = familyRadios.find((radio) => radio.checked).value;
      const finishes = data.products.filter((p) => p.family === family).map((p) => p.finish);
      finishRadios.forEach((radio) => { radio.disabled = !finishes.includes(radio.value); });
      if (!finishes.includes(finishRadios.find((radio) => radio.checked).value)) finishRadios.find((radio) => radio.value === finishes[0]).checked = true;
      const finish = finishRadios.find((radio) => radio.checked).value;
      const pick = (name) => data.products.find((p) => p.family === name && p.finish === finish) || data.products.find((p) => p.family === name);
      product = pick(family);
      el('racket-title').textContent = `${product.family} ${data.labels[product.finish]}`;
      setText('summary-model', `${product.family} ${data.labels[product.finish]}`);
      each('summary-image', image => {
        image.src = product.image;
        image.removeAttribute('srcset');
        image.alt = product.imageAlt;
      });
      el('racket-status').textContent = !product.available ? data.labels.soldOut : product.preorder ? data.labels.preorder : data.labels.stock;
      root.querySelectorAll('[data-model-card]').forEach((card) => {
        const item = pick(card.dataset.modelCard);
        const image = card.querySelector('[data-card-image]');
        if (image.getAttribute('src') !== item.image) {
          image.src = item.image;
          image.removeAttribute('srcset');
          image.alt = item.imageAlt;
        }
        card.querySelector('[data-card-price]').textContent = money(item.price);
      });
      el('racket-link').href = product.url;
      root.querySelectorAll('[data-recommend-family]').forEach((node) => {
        const item = pick(node.dataset.recommendFamily);
        node.disabled = !item || !item.available;
        node.setAttribute('aria-pressed', String(node.dataset.recommendFamily === family));
      });
      root.querySelectorAll('[data-recommend-link]').forEach((node) => {
        const item = pick(node.dataset.recommendLink);
        if (item) node.href = item.url;
      });
      root.querySelectorAll('[data-spec]').forEach((node) => { node.textContent = product.specs[node.dataset.spec] || '—'; });
      el('preview-image').setAttribute('href', product.preview);
      el('preview-path').setAttribute('d', product.previewPath);
      el('preview-text').setAttribute('fill', product.previewFill);
      el('preorder').hidden = !product.preorder;
      el('preorder-note').textContent = product.preorderNote || '';
      el('preorder-label').textContent = product.preorderAck || '';
      ack.checked = false;
      refresh();
    };
    [...familyRadios, ...finishRadios].forEach((radio) => radio.addEventListener('change', () => { choose(); engage(); pulse(); }));
    const quizResults = [...root.querySelectorAll('[data-quiz-result]')];
    quizResults.forEach((node) => { node.hidden = true; });
    root.querySelectorAll('[name=gift-level]').forEach((radio) => radio.addEventListener('change', () => {
      const group = radio.value;
      quizResults.forEach((node) => { node.hidden = node.dataset.quizResult !== group; });
    }));
    root.querySelectorAll('[data-recommend-family]').forEach((node) => node.addEventListener('click', () => {
      const radio = familyRadios.find((item) => item.value === node.dataset.recommendFamily);
      if (!radio) return;
      radio.checked = true;
      choose();
      engage();
      pulse();
      radio.focus({preventScroll:true});
      radio.closest('[data-model-card]').scrollIntoView({block:'center', behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }));
    root.querySelectorAll('[data-gift-film]').forEach((frame) => {
      const video = frame.querySelector('video');
      const play = frame.querySelector('button');
      const stop = () => {
        delete frame.dataset.started;
        video.controls = false;
        play.hidden = false;
      };
      video.controls = false;
      video.tabIndex = 0;
      play.hidden = false;
      play.addEventListener('click', async () => {
        video.controls = true;
        try {
          await video.play();
          frame.dataset.started = 'true';
          play.hidden = true;
          video.focus({preventScroll:true});
        } catch (_) { play.hidden = false; }
      });
      video.addEventListener('play', () => {
        root.querySelectorAll('[data-gift-film][data-started]').forEach((other) => { if (other !== frame) other.dispatchEvent(new Event('gift:stop')); });
      });
      video.addEventListener('ended', stop);
      frame.addEventListener('gift:stop', () => { video.pause(); stop(); });
    });
    root.querySelectorAll('[data-gift-slider]').forEach((slider) => {
      const track = slider.querySelector('[data-gift-slides]');
      const slides = Array.from(track.children);
      const previous = slider.querySelector('[data-gift-prev]');
      const next = slider.querySelector('[data-gift-next]');
      const current = slider.querySelector('[data-gift-slide-current]');
      let index = 0;
      const position = (slide) => slide.offsetLeft - slides[0].offsetLeft;
      const update = () => {
        index = slides.reduce((nearest, slide, i) => Math.abs(position(slide) - track.scrollLeft) < Math.abs(position(slides[nearest]) - track.scrollLeft) ? i : nearest, 0);
        if (current.textContent !== String(index + 1)) current.textContent = String(index + 1);
        previous.disabled = index === 0;
        next.disabled = index === slides.length - 1;
        slides.forEach((slide, i) => {
          if (i !== index) slide.querySelectorAll('[data-gift-film][data-started]').forEach((frame) => frame.dispatchEvent(new Event('gift:stop')));
        });
      };
      const move = (direction) => {
        const target = Math.max(0, Math.min(slides.length - 1, index + direction));
        track.scrollTo({left:position(slides[target]), behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('keydown', (event) => {
        if (event.target !== track || (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight')) return;
        event.preventDefault();
        move(event.key === 'ArrowLeft' ? -1 : 1);
      });
      track.addEventListener('scroll', update, {passive:true});
      slider.dataset.ready = 'true';
      slider.querySelector('[data-gift-gallery-controls]').hidden = slides.length < 2;
      update();
    });
    text.addEventListener('input', () => {
      if (text.value.trim() && !engraving.disabled) engraving.checked = true;
    });
    message.addEventListener('input', () => {
      if (message.value.trim() && !box.disabled) box.checked = true;
    });
    form.addEventListener('input', () => { refresh(); engage(); });
    form.addEventListener('change', event => { refresh(); engage(); if (event.target === engraving || event.target === box) pulse(); });
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (busy || uncertain || !product.available) return;
      refresh();
      closeDetails();
      const invalid = form.querySelector(':invalid');
      if (invalid) {
        invalid.scrollIntoView({block:'center', behavior:'instant'});
        invalid.focus({preventScroll:true});
        scheduleDock();
        form.reportValidity();
        return;
      }
      busy = true;
      el('gift-error').hidden = true;
      el('gift-success').hidden = true;
      const properties = {};
      const items = [{id:product.id, quantity:1, properties}];
      const stamp = crypto.randomUUID();
      if (engraving.checked) {
        const pair = `crown-${product.id}-${stamp}`;
        properties['Engraving — The Crown'] = text.value.trim();
        properties._pers_id = pair;
        properties._fee_variant = String(data.engraving.id);
        properties._pers_source = 'gift-page';
        items.push({id:data.engraving.id,quantity:1,properties:{Text:text.value.trim(),For:product.title,_service:'engraving',_pers_id:pair}});
      }
      if (box.checked) {
        const pair = `gift-${product.id}-${stamp}`;
        properties['Gift box'] = 'Included';
        properties._gift_id = pair;
        properties._gift_variant = String(data.box.id);
        properties._gift_source = 'gift-page';
        const feeProperties = {For:product.title,_service:'giftbox',_gift_id:pair};
        if (message.value.trim()) { properties['Gift message'] = message.value.trim(); feeProperties.Message = message.value.trim(); }
        items.push({id:data.box.id,quantity:1,properties:feeProperties});
      }
      refresh();
      try {
        const response = await fetch(data.addUrl, {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
        const result = await response.json();
        if (!response.ok || result.status) {
          if (response.status >= 500) uncertain = true;
          throw new Error(result.description || result.message || data.labels.error);
        }
        uncertain = true;
        el('gift-success').hidden = false;
        window.location.assign(data.cartUrl);
      } catch (error) {
        if (error instanceof TypeError || error instanceof SyntaxError) uncertain = true;
        el('gift-error').textContent = error.message || data.labels.error;
        if (uncertain) el('gift-error').textContent = data.labels.error;
        el('gift-error').hidden = false;
        el('gift-error').scrollIntoView({block:'center', behavior:'instant'});
        el('gift-error').focus({preventScroll:true});
      } finally { busy = false; refresh(); }
    });
    choose();
  }
  document.querySelectorAll('[data-gift-builder]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-gift-builder]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
